import { useCallback } from "react";

import { useMatch, useNavigate } from "react-router-dom";

import { setSubPage, AgentDesktopSubPages } from "Services/state/agent/desktopUI/AgentDesktopUISlice";
import { useRVDispatch } from "Services/state/Storage";
import { setActiveTask } from "Services/state/tasks/Thunks";

import type { RVTask } from "@regal-voice/shared-types";

export type UseNavigateToTaskOptions = {
    task?: RVTask;
};

export type UseNavigateToTaskResult = () => void;

export const useNavigateToTask = ({ task }: UseNavigateToTaskOptions = {}): UseNavigateToTaskResult => {
    const dispatch = useRVDispatch();
    const navigate = useNavigate();
    const isAgentDesktopPage = useMatch({ path: "/agent", end: true });

    return useCallback(() => {
        if (!task) {
            return;
        }
        if (!isAgentDesktopPage) {
            navigate(`/agent?sid=${task.sid}`);
        }
        dispatch(setSubPage(AgentDesktopSubPages.TASKS_PAGE));
        dispatch(setActiveTask(task));
    }, [task, isAgentDesktopPage, navigate, dispatch]);
};
